import { render, staticRenderFns } from "./CorporateTicketDetail.vue?vue&type=template&id=23aeaf27&scoped=true&"
import script from "./CorporateTicketDetail.vue?vue&type=script&lang=js&"
export * from "./CorporateTicketDetail.vue?vue&type=script&lang=js&"
import style0 from "./CorporateTicketDetail.vue?vue&type=style&index=0&id=23aeaf27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23aeaf27",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCard,VCol,VDialog,VIcon,VRow,VSelect})
